// extracted by mini-css-extract-plugin
export default {"container":"gL-z","dimension":"hL-z","dimensionLabels":"iL-z"};